import type { GridLayout } from './appSettings.service';
import {
  homePageWidgetPositions,
  type HomePageWidgetConfig,
} from '../pages/HomePage/constants';

/**
 * Prepare the grid from API for local use
 */
const mapWidgetKeys_backendToLocal = (
  backendGridLayout?: GridLayout | null,
): HomePageWidgetConfig =>
  homePageWidgetPositions.reduce<HomePageWidgetConfig>((acc, position) => {
    const backendWidgetKey = backendGridLayout?.[position] ?? '';

    acc[position] = backendWidgetKey;

    return acc;
  }, {} as HomePageWidgetConfig);

/**
 * Prepare the local grid for API call
 */
const mapWidgetKeys_localToBackend = (
  localGridLayout: Partial<HomePageWidgetConfig>,
): GridLayout =>
  homePageWidgetPositions.reduce<GridLayout>((acc, position) => {
    const localWidgetKey = localGridLayout[position] || '';

    acc[position] = localWidgetKey === '' ? null : localWidgetKey;

    return acc;
  }, {} as GridLayout);

export { mapWidgetKeys_backendToLocal, mapWidgetKeys_localToBackend };
